type SenderBackHandler = () => boolean;

let handler: SenderBackHandler | null = null;

/** Nested wizards claim Telegram BackButton before the shell navigates away. */
export function setSenderBackOverride(next: SenderBackHandler | null) {
	handler = next;
}

export function consumeSenderBackOverride(): boolean {
	return handler?.() ?? false;
}
